export const LAST_SONG_TIMER_LENGTH = 10;
export const LAST_SONG_TIMER_LENGTH_IN_MS = LAST_SONG_TIMER_LENGTH * 1000;
export const TEN_SECONDS_MS = 10000;
export const HALF_HOUR_MS = 1800000;
export const THIRTY_SECONDS_MS = 30 * 1000;
export const TWEENTY_MINUTES_MS = 20 * 60 * 1000;
export const TEN_MINUTES_MS = 10 * 60 * 1000;
